import { render, staticRenderFns } from "./LogoBomberos.vue?vue&type=template&id=9530cfd8&scoped=true&"
import script from "./LogoBomberos.vue?vue&type=script&lang=js&"
export * from "./LogoBomberos.vue?vue&type=script&lang=js&"
import style0 from "./LogoBomberos.vue?vue&type=style&index=0&id=9530cfd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9530cfd8",
  null
  
)

export default component.exports